
import { Component } from "nuxt-property-decorator"
import Header from "~/mixins/header"

@Component
export default class TheHeaderDEComponent extends Header {
  isMouseInside = false
  mouseTimeoutID: any

  handleMouseEnterPanelMenu() {
    this.isMouseInside = true
    if (this.mouseTimeoutID) {
      clearTimeout(this.mouseTimeoutID)
    }
  }

  handleMouseLeavePanelMenu() {
    this.isMouseInside = false
    this.mouseTimeoutID = setTimeout(() => {
      if (!this.isMouseInside) {
        this.hidePanelMenu()
      }
    }, 500)
  }

  hidePanelMenu() {
    this.showPanelMenu = false
    this.showMenuSection = false
  }

  handleMenuLeave() {
    this.handleMouseLeavePanelMenu()
  }
}
